enum EstadosModalTraslados {
    CERRADO = 'CERRADO',
    CREACION = 'CREACION',
    EDICION = 'EDICION',
    VISUALIZACION = 'VISUALIZACION',
}

export { EstadosModalTraslados };
